
import { Vue, prop } from "vue-class-component";
import { HangingIncomingSummary, ByStatusDetail } from "@/domain/entities/HangingIncoming";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";

class Props {
  dataSummary = prop<HangingIncomingSummary>({
    default: () => ({}),
    type: Object,
  });
}

class HeaderSummaryHangingIncoming extends Vue.with(Props) {
  formatDate = formatDate

  get allCards() {
    // summary cards
    const summary = [
      {
        type: "summary",
        icon: require("@/app/ui/assets/svg/total-active-awb-hanging.svg"),
        alt: "total-active-awb-hanging",
        label: this.$t("dashboard.hanging.activity"),
        pending: this.dataSummary.activitiesPending,
        done: this.dataSummary.activitiesDone,
        total: this.dataSummary.totalActivities,
      },
      {
        type: "summary",
        icon: require("@/app/ui/assets/svg/total-active-awb-hanging.svg"),
        alt: "total-awb-hanging",
        label: this.$t("dashboard.hanging.awb"),
        pending: this.dataSummary.awbHangingPending,
        done: this.dataSummary.awbHangingDone,
        total: this.dataSummary.totalAwbHanging,
      },
      {
        type: "summary",
        icon: require("@/app/ui/assets/svg/total-bag-hanging.svg"),
        alt: "total-bag-hanging",
        label: this.$t("dashboard.hanging.bag"),
        pending: this.dataSummary.bagHangingPending,
        done: this.dataSummary.bagHangingDone,
        total: this.dataSummary.totalBagHanging,
      },
      {
        type: "summary",
        icon: require("@/app/ui/assets/svg/total-stt-hanging.svg"),
        alt: "total-stt-hanging",
        label: this.$t("dashboard.hanging.stt"),
        pending: this.dataSummary.sttHangingPending,
        done: this.dataSummary.sttHangingDone,
        total: this.dataSummary.totalSttHanging,
      },
    ];

    // status cards
    const statusTemplates = [
      { icon: require("@/app/ui/assets/svg/plane-hanging.svg"), alt: "plane", status: "CARGO PLANE ARR" },
      { icon: require("@/app/ui/assets/svg/truck-hanging.svg"), alt: "truck", status: "DROPOFF TRUCKING" },
      { icon: require("@/app/ui/assets/svg/shortland-hanging.svg"), alt: "shortland", status: "SHORTLAND" },
      { icon: require("@/app/ui/assets/svg/sti-dest-hanging.svg"), alt: "sti-dest", status: "STI-DEST" },
    ];

    const status = statusTemplates.map((tpl, i) => {
      const s = (this.dataSummary.byStatus && this.dataSummary.byStatus.find(item => item.status === tpl.status)) || new ByStatusDetail();
      return {
        type: "status",
        icon: tpl.icon,
        alt: tpl.alt,
        status: tpl.status,
        awb: s.awb || 0,
        totalBag: s.totalBag || 0,
        totalStt: s.totalStt || 0,
      };
    });

    return [...summary, ...status];
  }
}
export default HeaderSummaryHangingIncoming;
